export const colorsPalette = {
  primary: {
    DEFAULT: '#252422',
    main: '#252422',
    dark: '#1E1E1E',
    light: '#252422',
    contrastText: '#fff',
  },
  secondary: {
    DEFAULT: '#252422',
    main: '#252422',
    dark: '#252422',
    light: '#51504E',
  },
  third: {
    DEFAULT: '#64748B',
    main: '#64748B',
    dark: '#64748B',
    light: '#64748B',
  },
  four: {
    DEFAULT: '#f46a00',
    main: '#f46a00',
    dark: '#f46a00',
    light: '#f46a00',
  },
  six: {
    DEFAULT: '#1EC2F5',
    main: '#1EC2F5',
    dark: '#1EC2F5',
    light: '#1EC2F5',
  },
  five: {
    DEFAULT: '#d32f2f',
    main: '#d32f2f',
    dark: '#d32f2f',
    light: '#d32f2f',
  },
  active: {
    DEFAULT: '#f0b337',
    main: '#f0b337',
    dark: '#f0b337',
    light: '#f0b337',
  },
  pending: {
    DEFAULT: '#F5851E',
    main: '#F5851E',
    dark: '#F5851E',
    light: '#F5851E',
  },

  info: {
    DEFAULT: '#2686EC',
    main: '#2686EC',
    dark: '#2686EC',
    light: '#2686EC',
  },
  success: {
    DEFAULT: '#12B76A',
    main: '#12B76A',
    dark: '#12B76A',
    light: '#12B76A',
  },
  error: { DEFAULT: '#D32F2F', main: '#D32F2F', dark: '#D32F2F', light: '#D32F2F' },
  action: {
    DEFAULT: '#2686EC',
    main: '#2686EC',
  },

  mbg: {
    DEFAULT: '#fff',
    light: '#fff',
    dark: '#101214',
  },
  mbgSecond: {
    DEFAULT: '#F4F5F8',
    light: '#F4F5F8',
    dark: '#0d1216',
  },
  bd: {
    DEFAULT: 'rgba(0,0,0,.1)',
    main: 'rgba(0,0,0,0.1)',
    dark: 'rgba(61,71,81,0.4)',
    second: 'rgba(0,0,0,0.2)',
  },
  input: {
    text: {
      DEFAULT: '#252422',
      light: '#252422',
      dark: '#f8f8f2',
    },
    background: {
      DEFAULT: '#fff',
      light: '#fff',
      dark: '#0D1216',
    },
    autofill: {
      background: {
        DEFAULT: '#FEF0E6',
        light: '#FEF0E6',
        dark: '#FEF0E6',
      },
      text: {
        DEFAULT: '#F46A00',
        light: '#F46A00',
        dark: '#F46A00',
      },
    },
    placeholder: {
      DEFAULT: 'rgba(0, 0, 0, 0.5)',
      light: 'rgba(0, 0, 0, 0.5)',
      dark: '#fff',
    },
    border: {
      color: {
        DEFAULT: 'rgba(0,0,0,0.1)',
        light: 'rgba(0,0,0,0.1)',
        dark: 'rgba(61,71,81,0.4)',
      },
      focus: {
        color: {
          DEFAULT: '#252422',
          light: '#252422',
          dark: '#252422',
        },
      },
    },
  },
}
